const BYTE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'] as const
const BYTES_PER_UNIT = 1024
const BYTES_PER_MEGABYTE = BYTES_PER_UNIT * BYTES_PER_UNIT

export function formatFileSize(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes <= 0) {
    return '0 B'
  }
  if (bytes < BYTES_PER_UNIT) {
    return `${bytes} B`
  }

  let value = bytes
  let unitIndex = 0
  while (value >= BYTES_PER_UNIT && unitIndex < BYTE_UNITS.length - 1) {
    value /= BYTES_PER_UNIT
    unitIndex += 1
  }

  return `${value.toFixed(1)} ${BYTE_UNITS[unitIndex]}`
}

export function formatFileSizeFromMegabytes(megabytes: number): string {
  if (!Number.isFinite(megabytes) || megabytes <= 0) {
    return '0 B'
  }
  return formatFileSize(megabytes * BYTES_PER_MEGABYTE)
}
